
import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';

import { TargetingGeographyService } from '@Common/TargetingShared/services/targeting-geography-service';
import { TargetingSearchLanguageSelectDialogService } from '@Common/TargetingShared/services/targeting-search-language-select-dialog.service';
import { TargetingSearchRegionSelectDialogService } from '@Common/TargetingShared/services/targeting-search-region-select-dialog.service';
import { DropdownOptionModel } from '@Common/Forms/models/dropdown-option.model';
import { messageSeverityEnum } from '@Common/Misc/enums/message-severity.enum';
import { AgprComponentStyleEnum } from '@Common/Basic/enums/social-analysis-types.enum';
import { IncludeExcludeModel } from '@Common/Misc/models/include-exclude-model';

import { CoreDialogService } from '@Core/Dialogs/services/dialog.service';
import { LocalizationService } from '@Core/Localization/services/localization.service';
import { CurrentUserStateService } from '@Core/Users/services/current-user-state.service';

import { JournodexEnumsService } from '@Discover/Core/services/journodex-enums.service';
import { ContactSearchComponent } from '@Discover/Targeting/components/TargetingSearch/ContactSearch/contact-search.component';
import { JournodexEntityFactory } from '@Discover/Targeting/factories/journodex-entity.factory';
import { JobRoleSelectDialogService } from '@Discover/Targeting/services/jobrole-select-dialog.service';
import { TargetingSearchesService } from '@Discover/Targeting/services/targeting-searches.service';

@Component({
    selector: 'agpr-quick-edit-search',
    templateUrl: './quick-edit-search.component.html',
    styleUrls: ['./quick-edit-search.component.scss'],
    providers: [
        TargetingSearchRegionSelectDialogService,
        TargetingSearchLanguageSelectDialogService,
        JobRoleSelectDialogService,
    ],
    standalone: false
})
export class QuickEditSearchComponent extends ContactSearchComponent {
    readonly messageSeverities = messageSeverityEnum;
    readonly agprComponentStyle = AgprComponentStyleEnum;

    @Input() set searchParamsVisible (searchParamsVisible: any) {
        this._searchParamsVisible = searchParamsVisible;
        this.checkIfContactEmpty();
        this.checkIfOutletEmpty();

    }
    _searchParamsVisible: any;
    @Input() contactSearchParams: DropdownOptionModel[] = [];
    @Input() outletSearchParams: DropdownOptionModel[] = [];

    contactParamsEmpty: boolean = false;
    outletParamsEmpty: boolean = false;

    contactParams: string [] = ['contactIdsNames', 'monitoringKeywords', 'subjects', 'geographies', 'jobTitles', 'jobRoles', 'languages'];
    outletParams: string [] = ['outletIdsNames', 'outletMonitoringKeywords', 'outletSubjects', 'areasOfCoverage', 'mediaMarkets'];

    constructor(
        public targetingSearchesService: TargetingSearchesService,
        public journodexEnumsService: JournodexEnumsService,
        public localizationService: LocalizationService,
        public targetingGeographyService: TargetingGeographyService,
        protected regionSelectDialogService: TargetingSearchRegionSelectDialogService,
        protected coreDialogService: CoreDialogService,
        protected journodexEntityFactory: JournodexEntityFactory,
        protected languageSelectDialogService: TargetingSearchLanguageSelectDialogService,
        protected jobRoleSelectDialogService: JobRoleSelectDialogService,
        protected messageService: MessageService,
        protected currentUserStateService: CurrentUserStateService
    ) {
        super(targetingSearchesService,
            journodexEnumsService,
            localizationService,
            targetingGeographyService,
            regionSelectDialogService,
            coreDialogService,
            journodexEntityFactory,
            languageSelectDialogService,
            jobRoleSelectDialogService,
            messageService,
            currentUserStateService
        );
    }

    handleContactChange(event) {
        this._searchParamsVisible[event.value?.value] = true;
        const index = this.contactSearchParams.findIndex(param => param.value === event.value?.value);
        if (index > -1) {
            this.contactSearchParams.splice(index, 1);
        }
        this.checkIfContactEmpty();
    }

    handleOutletChange(event) {
        this._searchParamsVisible[event.value?.value] = true;
        const index = this.outletSearchParams.findIndex(param => param.value === event.value?.value);
        if (index > -1) {
            this.outletSearchParams.splice(index, 1);
        }
        this.checkIfOutletEmpty();
    }

    checkIfContactEmpty() {
        let isEmpty = true;
        for (const param of this.contactParams) {
            if (this._searchParamsVisible[param]) {
                isEmpty = false;
                break;
            }
        }
        this.contactParamsEmpty = isEmpty;
    }

    checkIfOutletEmpty() {
        let isEmpty = true;
        for (const param of this.outletParams) {
            if (this._searchParamsVisible[param]) {
                isEmpty = false;
                break;
            }
        }
        this.outletParamsEmpty = isEmpty;
    }

    removeParam(key: string) {
        if (key === 'contacts') {
            this._searchParamsVisible['contactIdsNames'] = false;
        } else if (key === 'keywords') {
            this._searchParamsVisible['monitoringKeywords'] = false;
        } else {
            this._searchParamsVisible[key] = false;
        }

        if (key === 'contacts') {
            this.contactForm.get(key).patchValue([]);
        } else {
            this.contactForm.get(key).patchValue(new IncludeExcludeModel());
        }
        this.checkIfContactEmpty();
    }

    removeParamOutlook(key: string) {
        if (key === 'outlets') {
            this._searchParamsVisible['outletIdsNames'] = false;
        } else if (key === 'outletKeywords') {
            this._searchParamsVisible['outletMonitoringKeywords'] = false;
        } else {
            this._searchParamsVisible[key] = false;
        }

        if (key === 'outlets') {
            this.contactForm.get('employment').get(key).patchValue([]);
        } else {
            this.contactForm.get('employment').get(key).patchValue(new IncludeExcludeModel());
        }
        this.checkIfOutletEmpty();
    }
}
